import React, { useState } from 'react'
import CloseSVG from '../../../assets/svg/close.svg'
import Modal from '../modal'
import Button from '../../button'
import ButtonSelect from '../../button-select'
import RunBasicPayroll from './run-basic-payroll'
import RunBulkBasicPayroll from './run-bulk-basic-payroll'
import WarningSVG from '../../../assets/svg/warning.svg'

function SelectPaymentOption({ isOpen, closeModal, refresh }) {
  const [option, setOption] = useState('basic')
  const [basicPayroll, setBasicPayroll] = useState(false)
  const [advancedPayroll, setAdvancedPayroll] = useState(false)

  function submit() {
    if (option === 'basic') {
      setBasicPayroll(true)
    } else if (option === 'advanced') {
      setAdvancedPayroll(true)
    }
  }

  return (
    <>
      {basicPayroll ? (
        <RunBasicPayroll
          isOpen={basicPayroll}
          source='default'
          closeModal={() => setBasicPayroll(false)}
        />
      ) : null}
      {advancedPayroll ? (
        <RunBulkBasicPayroll
          isOpen={advancedPayroll}
          source='default'
          closeModal={() => {
            setAdvancedPayroll(false)
            closeModal()
          }}
        />
      ) : null}
      <Modal
        scrollable={true}
        className='!max-w-[600px] !rounded-none overflow-auto'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Select payment option</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col items-center w-full gap-3'>
            <p className='text-[15px] -mb-6'>
              Select your desired option to make payment
            </p>
            <div className='flex flex-col justify-center h-full min-h-[550px] max-w-[85%] w-full'>
              <ButtonSelect
                title={'Basic Employee Payment'}
                subtitle={'Add employee payment'}
                isActive={option === 'basic'}
                onClick={() => setOption('basic')}
              />

              <ButtonSelect
                title={'Import Employee Payment'}
                subtitle={'Import Payment using a pre-defined XLSX template'}
                isActive={option === 'advanced'}
                onClick={() => setOption('advanced')}
                className='mt-8'
              />
              <div className='flex flex-col my-3 px-4 border-secondary-4 border-[1.2px] rounded-lg p-3 mt-2 bg-color-warning-light w-[100%]'>
                <div className='flex'>
                  <div className='w-[100px] pr-2 flex flex-row items-center '>
                    <img src={WarningSVG} alt='' srcSet='' />
                  </div>
                  <div className='text-[12px] text-justify'>
                    <span className='font-normal'>
                      <span className='font-extrabold'>Please Note: </span>
                      This method pays employees using only the net pay you
                      provide (can be edited on the next page). It does not
                      compute payroll. To run full payroll, go to the Payroll
                      Summary tab and click "RUN PAYROLL."
                      <br />{' '}
                      <span className='font-extrabold'>
                        Payslip Option:
                      </span>{' '}
                      You can now choose to generate and download payslips for
                      these payments, which incurs a small charge per payslip.{' '}
                    </span>
                  </div>
                </div>
              </div>

              <div className='w-full mt-[20px]'>
                <Button text='NEXT' type='submit' onClick={() => submit()} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SelectPaymentOption
